import { Wrench } from 'lucide-react';

import { Button } from '@shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shared/components/ui/tooltip';

import { useUser } from '@features/user-access/providers/user-provider';

export const AdminButton = () => {
  const { userAccess } = useUser();

  if (!userAccess.adminUrl) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button aria-label="Accès administrateur" asChild className="min-w-10" size="sm" variant="soft">
          <a href={userAccess.adminUrl} rel="noopener noreferrer" target="_blank">
            <Wrench />
          </a>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="left">Accès administrateur</TooltipContent>
    </Tooltip>
  );
};
